import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../assets/tatvam-logo.png';

export default function Footer() {
  return (
    <footer className="bg-white text-gray-700 py-12 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          
          <div>
            <div className="flex items-center mb-4">
              <img 
                src={logo} 
                alt="Tatvam Logo" 
                className="h-16 w-auto object-contain" 
              />
            </div>
            <p className="text-sm leading-relaxed mb-4 text-gray-600">
              Premium Suiting & Shirting Retail & Custom Tailoring.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-900 mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li>Email: hello@tatvamretail.in</li>
              <li>Call/WhatsApp: +91 91191 23305</li>
              <li className="leading-relaxed">Address: 9 Ganesham, Ajmer Road, Shyam Nagar No. 2, Behind Sodhani Sweets, Sodala, Jaipur</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-900 mb-4">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li><Link to="/privacy-policy" className="hover:text-[#d4af37] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" className="hover:text-[#d4af37] transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/shipping-policy" className="hover:text-[#d4af37] transition-colors">Shipping & Service Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 text-center md:text-left space-y-2">
          <p className="text-xs text-gray-900 uppercase tracking-widest font-bold">
            Tatvam is a brand owned and operated by Yashvi Enterprises.
          </p>
          <p className="text-[10px] text-gray-500 uppercase tracking-widest font-medium">
            This brand operates under the verified business entity Yashvi Enterprises.
          </p>
        </div>
      </div>
    </footer>
  );
}